import f from "../../funcs";
import DragModal from "./DragModal";
import langDictionary from "../lang/init";
import Focus from "../grid/behavior/Focus";
import "../../plugins/realSize";


let UIModal = DragModal.extend("UIModal", {});

UIModal.prototype.init = function(params, _UIModalName) {
    let focusedGrid = Focus.getFocusedGrid();
    Focus.blurAllGrids();

    if ( typeof params == "string" ) {
        params = { text: langDictionary.get(params) || params };
    }

    params = f.deepMixin({
        autoSize: true,
        iresize: false,
        ifull: false,
        icon: false,
        buttons: {
            ok: true,
            cancel: true
        },
        text: "",
        textarea: false,
        onConfirm() {},
        onSuccess() {},
        onCancel() {},
        show: true,
        title: "",
        onClickDetails() {}
    }, params);

    let hasDetails = f.isString(params.details) && params.details.trim();

    if ( params.title ) {
        params.title = langDictionary.get(params.title);
    }

    if ( params.text ) {
        params.text = langDictionary.get(params.text);
    }

    params._mobileFull = false;
    DragModal.prototype.init.call(this, params);

    this.$.addClass("ui-modal tab-area " + _UIModalName);
    this.$.data("tab-area", this);

    if ( params.cssName ) {
        this.$.addClass(params.cssName);
    }

    let $box = this.$box;
    let okText = langDictionary.get("ok");
    if ( params.okText ) {
        okText = langDictionary.get(params.okText) || params.okText;
    }

    $box.html([
        "<form><p class='text'>",
        params.icon ? "<span class='icon fa'></span>" : "",
        params.text,
        "</p>",
        (
            hasDetails ? (
                "<a class='toggle-details no-select'>"
                        + langDictionary.get("uimodal_toggle_details")
                    + "</a>"
            ) : ""
        ),
        params.textarea ? "<textarea class='form-control'></textarea>" : "",
        "<div class='select-buttons'><div class='select-buttons-inner'>",
        params.buttons.ok ? "<button class='btn btn-primary ok tab-elem'>" + okText + "</button>" : "",
        params.buttons.cancel ? "<button class='btn btn-default cancel tab-elem'>" + langDictionary.get("Cancel") + "</button>" : "",
        "</div>",
        "</div>",

        (
            hasDetails ? (
                "<div style='clear:both'></div>"
                    + "<div class='details'>"
                    + params.details
            + "</div>"
            ) : ""
        )
            + "</form>"
    ].join(""));

    if ( hasDetails ) {
        this.$.addClass("has-details");
    }

    let size = this.$.realSize();
    this.width = size.width;
    this.height = size.height;
    this.autoSize();
    // кнопки
    let onConfirm = params.onConfirm;
    let onSuccess = params.onSuccess;
    let onCancel = params.onCancel;
    let $textarea = $box.find("textarea");

    $box.find(".btn").eq(0).focus();

    this.listenTo($box.find(".ok:first"), "click", function(e) {
        let value;
        let result;

        if ( params.textarea ) {
            value = $textarea.val();
            result = onConfirm(value);
            result = result || onSuccess(value);
        } else {
            result = onConfirm();
            result = result || onSuccess();
        }

        if ( result === false ) {
            e.preventDefault();
            return;
        }
        // lw-5246 могут вначале закрыть таблицу, а потом нажать ок
        if ( focusedGrid && focusedGrid.behavior ) {
            Focus.focusGrid(focusedGrid);
        }

        this.hide();
    }.bind(this));

    this.listenTo($box.find(".cancel:first"), "click", function(e) {
        let result = onCancel();

        if ( result === false ) {
            e.preventDefault();
            return;
        }
        // lw-5246 могут вначале закрыть таблицу, а потом нажать отмену
        if ( focusedGrid && focusedGrid.behavior ) {
            Focus.focusGrid(focusedGrid);
        }

        this.hide();
    }.bind(this));

    this.listenTo($box.find(".toggle-details"), "click", function(e) {
        e.preventDefault();
        this.$.toggleClass("details-show");
    }.bind(this));

    if ( params.onClickDetails ) {
        this.listenTo($box.find(".details"), "click", function(e) {
            e.preventDefault();
            params.onClickDetails(e);
        }.bind(this));
    }

    if ( params.show ) {
        this.show();
    }

    return this;
};

UIModal.prototype.on_hide = function() {
    if ( DragModal.prototype.on_hide ) {
        DragModal.prototype.on_hide.apply(this, arguments);
    }

    this.destroy();
};

UIModal.prototype.destroy = function() {
    if ( this.params && this.params.onDestroy ) {
        this.params.onDestroy();
    }
    DragModal.prototype.destroy.apply(this, arguments);
};

UIModal.prototype.focusEnter = function($elem) {
    $elem.click();
};

UIModal.__params = function(defParams, params) {
    if ( typeof params == "string" ) {
        params = { text: params };
    }

    return f.deepMixin(defParams, params);
};

UIModal.prompt = function(params) {
    return new UIModal(UIModal.__params({ textarea: true }, params), "prompt");
};

UIModal.confirm = function(params) {
    return new UIModal(UIModal.__params({ title: langDictionary.get("default_confirm_window_title") }, params), "confirm");
};

UIModal.warning = function(params) {
    return new UIModal(UIModal.__params({ icon: true,title: langDictionary.get("Warning") }, params), "warning");
};

UIModal.error = function(params) {
    return new UIModal(UIModal.__params({ icon: true,title: langDictionary.get("Error") }, params), "error");
};

UIModal.alert = function(params) {
    return new UIModal(UIModal.__params({ title: langDictionary.get("Alert") }, params), "js-alert");
};

UIModal.success = function(params) {
    return new UIModal(UIModal.__params({}, params), "success");
};

UIModal.yesno = function(params) {
    params = params || {};
    const onYes = f.isFunction(params.onYes) ? params.onYes : function() {};
    const onNo = f.isFunction(params.onNo) ? params.onNo : function() {};
    const onCancel = f.isFunction(params.onCancel) ? params.onCancel : function() {};
    const text = params.strictText ? params.text : langDictionary.get(params.text);
    const details = params.details;
    let textYes;
    let textNo;
    const modal = new UIModal(
        {
            text,
            title: params.title,
            onDestroy: params.onDestroy,
            details,
            onClickDetails: params.onClickDetails
        },
        "yes-no"
    );
    const $box = modal.$box;
    const $buttonsWrap = $box.find(".select-buttons-inner");

    if ( params.textYes ) {
        textYes = params.strictTextYes ? params.textYes : langDictionary.get(params.textYes);
    } else {
        textYes = langDictionary.get("Yes");
    }

    if ( params.textNo ) {
        textNo = params.strictTextNo ? params.textNo : langDictionary.get(params.textNo);
    } else {
        textNo = langDictionary.get("No");
    }

    $buttonsWrap.html([
        "<button class='btn btn-primary btn-yes tab-elem'>",
        textYes,
        "</button>",
        "<button class='btn btn-default btn-no tab-elem'>",
        textNo,
        "</button>",
        "<button class='btn btn-default btn-cancel tab-elem'>",
        langDictionary.get("Cancel"),
        "</button>"
    ].join(""));

    // TODO: был коммит, который чинит утечки заменой этого на this.listenTo, но сначала нужно унаследовать от EE

    $buttonsWrap.find(".btn-yes").click(() => {
        onYes();
        modal.hide();
    });

    $buttonsWrap.find(".btn-no").click(() => {
        onNo();
        modal.hide();
    });

    $buttonsWrap.find(".btn-cancel").click(() => {
        onCancel();
        modal.hide();
    });

    return modal;
};

UIModal.yesnoAsync = async (params) => {
    params = params || {};
    const onYes = f.isFunction(params.onYes) ? params.onYes : function() {};
    const onNo = f.isFunction(params.onNo) ? params.onNo : function() {};
    const onCancel = f.isFunction(params.onCancel) ? params.onCancel : function() {};
    const text = params.strictText ? params.text : langDictionary.get(params.text);
    const details = params.details;
    let textYes;
    let textNo;

    if ( params.textYes ) {
        textYes = params.strictTextYes ? params.textYes : langDictionary.get(params.textYes);
    } else {
        textYes = langDictionary.get("Yes");
    }

    if ( params.textNo ) {
        textNo = params.strictTextNo ? params.textNo : langDictionary.get(params.textNo);
    } else {
        textNo = langDictionary.get("No");
    }

    let isResolvedOrRejected = false;
    const resolveYesNo = (response) => {
        if ( response == "yes" ) {
            onYes();
        } else {
            onNo();
        }
        isResolvedOrRejected = true;
    };

    const UIModalYesNoPromise = new Promise((resolve, reject) => {
        const resolveYes = () => {resolve("yes");};
        const resolveNo = () => {resolve("no");};

        return UIModal.yesno({
            text,
            textYes,
            textNo,
            onYes: resolveYes,
            onNo: resolveNo,
            onCancel: () => {
                isResolvedOrRejected = true;
                reject();
            },
            onDestroy: () => !isResolvedOrRejected && reject(),
            details,
            onClickDetails: params.onClickDetails
        }
        );
    });

    await UIModalYesNoPromise.then(resolveYesNo, onCancel);
};

UIModal.removeOrUnlink = function(params) {
    params = params || {};
    const onRemove = f.isFunction(params.onRemove) ? params.onRemove : function() {};
    const onUnlink = f.isFunction(params.onUnlink) ? params.onUnlink : function() {};
    const onCancel = f.isFunction(params.onCancel) ? params.onCancel : function() {};
    const text = params.strictText ? params.text : langDictionary.get(params.text);
    const modal = new UIModal(UIModal.__params({ title: langDictionary.get("choose_action") } , { text }), "remove-or-unlink");
    const $box = modal.$box;
    const $buttonsWrap = $box.find(".select-buttons-inner");

    $buttonsWrap.html([
        "<button class='btn btn-primary btn-remove tab-elem'>",
        langDictionary.get("Remove"),
        "</button>",
        "<button class='btn btn-default btn-unlink tab-elem'>",
        langDictionary.get("Unlink"),
        "</button>",
        "<button class='btn btn-default btn-cancel tab-elem'>",
        langDictionary.get("Cancel"),
        "</button>"
    ].join(""));

    // TODO: был коммит, который чинит утечки заменой этого на this.listenTo, но сначала нужно унаследовать от EE

    $buttonsWrap.find(".btn-remove").click(() => {
        onRemove();
        modal.hide();
    });

    $buttonsWrap.find(".btn-unlink").click(() => {
        onUnlink();
        modal.hide();
    });

    $buttonsWrap.find(".btn-cancel").click(() => {
        onCancel();
        modal.hide();
    });

    return modal;
};

export default UIModal;
